APPS.course.earthScienceCourseForm = (function(e){
    var show = function(e){
	    console.log('form page')
        APP.getView().showChildView('mainRegion', new pageView() )
			
		window.document.title = 'DOWNLOAD FORM';
		if(typeof ga !== "undefined" ){ ga('send','pageview',{ page:"/", title:'DOWNLOAD FORM' }) }
		}
     
    /***********************************************************************
	 ***********************************************************************
	    VIEWS 
	 ***********************************************************************
	 ***********************************************************************/
        var pageView = Mn.View.extend({
			template: _.template($("#template_earth_science_course_form").html())
			,className:"page_form mt8"
			,events:{
				"click #btnFormSubmit":"submit"
			}
			,submit:function(e){
				e.preventDefault();
				console.log('yo')
				
				var formData = new FormData($('form')[0]);
				
				
				//Errors
				var errors=[];
				var i=0;
				var htm ="";
				
				if(!formData.get('fname')){ errors[i++] = "First Name is required." }
				if(!formData.get('lname')){ errors[i++] = "Last Name is required." }
				if(!formData.get('email')){ errors[i++] = "Email is required." }
				if(!formData.get('terms')){ errors[i++] = "Please accept the Terms and Conditions." }
				console.log(errors)
				
				if(errors.length){
					htm ="<h1 class='h2 danger'>Hmm... looks like there's an error.</h1>";
					htm += "<ul>";
					for(i=0,l=errors.length;i<l;i++){
						htm += "<li>" + errors[i] + "</li>";
					}
					htm += "</ul>";
					$('#formErrorContainer').html(htm).show();
				}
				
				//var a = $.post("/api/form.php",$( "form" ).serialize() )
				var a = $.ajax({
					url:"/api/earth_science_course_form.php"
					,data:$( "form" ).serialize() 
					,type:"POST"
					,dataType:"json"
				});
				a.done(function(r){
					var htm = "";
					$('#formErrorContainer').html(htm).hide();
					
					if(r && r.success==true){
						//show thanks, start download
						$('form').hide();
						$('#thankyouContainer').removeClass('d-none');
						window.location.href="/api/earth_science_course_dl.php?id="+( +formData.get('id') );
						
					}else{
						//throw errors
						htm ="<h1 class='h2 danger'>Hmm... looks like there's an error.</h1>";
						htm += "<ul>";
							
						if(r && r.errors && r.errors.length){
							for(i=0,l=r.errors.length;i<l;i++){
								htm += "<li>" + r.errors[i] + "</li>";
							}
						}else{
							htm += "<li>Unknown error. Please try again later.</li>";
						}
						htm += "</ul>";
						$('#formErrorContainer').html(htm).show();
					}
				})
			}
	        
	    })
	    
    return {
        show:show
    }
})();